import paymentService from '@/services/tmed-plans/payment.service';
import paymentMethodService from '@/services/tmed-plans/payment-method.service';

const state = {
  payment: null,
  createPaymentStatus: 'init',
  getInvoiceStatus: 'init',
  getPaymentHistoryStatus: 'init',
  error: null,
  pixData: null,
  paymentMethods: [],
  paymentMethod: null,
  registerPaymentMethodStatus: 'init',
  getPaymentMethodsStatus: 'init',
  updatePaymentMethodStatus: 'init',
  deletePaymentMethodStatus: 'init',
};

const getters = {
  getPayment: (state) => state.payment,
  getCreatePaymentStatus: (state) => state.createPaymentStatus,
  getError: (state) => state.error,
  getPixData: (state) => state.pixData,
  getPaymentMethods: (state) => state.paymentMethods,
  getPaymentMethod: (state) => state.paymentMethod,
  getRegisterPaymentMethodStatus: (state) => state.registerPaymentMethodStatus,
  getGetPaymentMethodsStatus: (state) => state.getPaymentMethodsStatus,
  getUpdatePaymentMethodStatus: (state) => state.updatePaymentMethodStatus,
  getDeletePaymentMethodStatus: (state) => state.deletePaymentMethodStatus,
  getGetInvoiceStatus: (state) => state.getInvoiceStatus,
  getGetPaymentHistoryStatus: (state) => state.getPaymentHistoryStatus,
};

const actions = {
  async getInvoice({ commit }, invoiceId) {
    try {
      commit('SET_GET_INVOICE_STATUS', 'loading');
      const data = await paymentService.getInvoice(invoiceId);
      commit('SET_GET_INVOICE_STATUS', 'init');
      return data;
    } catch (error) {
      commit('SET_ERROR', error?.response?.data?.message || 'Erro ao buscar fatura');
      commit('SET_GET_INVOICE_STATUS', 'init');
      throw error;
    }
  },

  async getPaymentHistory({ commit }, { offset = 0, limit = 5, type } = {}) {
    try {
      commit('SET_GET_PAYMENT_HISTORY_STATUS', 'loading');
      const params = { offset, limit };
      if (type) params.type = type;
      const data = await paymentService.getPaymentHistory(params);
      commit('SET_GET_PAYMENT_HISTORY_STATUS', 'init');
      return data;
    } catch (error) {
      commit('SET_ERROR', error?.response?.data?.message || 'Erro ao buscar histórico de pagamentos');
      commit('SET_GET_PAYMENT_HISTORY_STATUS', 'init');
      throw error;
    }
  },

  async reprocessPayment({ commit }, { paymentMethodId, invoiceId }) {
    try {
      const data = await paymentService.reprocessPayment(paymentMethodId, invoiceId);
      return data;
    } catch (error) {
      commit('SET_ERROR', error?.response?.data?.message || 'Erro ao reprocessar pagamento');
      throw error;
    }
  },

  clearPayment({ commit }) {
    commit('CLEAR_PAYMENT');
  },

  async registerPaymentMethod({ commit }, paymentMethodData) {
    try {
      commit('SET_REGISTER_PAYMENT_METHOD_STATUS', 'loading');
      const response = await paymentMethodService.createPaymentMethod(paymentMethodData);
      commit('SET_PAYMENT_METHOD', response);
      commit('SET_REGISTER_PAYMENT_METHOD_STATUS', 'init');
      return response;
    } catch (error) {
      commit('SET_ERROR', error?.response?.data?.message || 'Erro ao cadastrar método de pagamento');
      commit('SET_REGISTER_PAYMENT_METHOD_STATUS', 'init');
      throw error;
    }
  },

  async getPaymentMethods({ commit }, params) {
    try {
      commit('SET_GET_PAYMENT_METHODS_STATUS', 'loading');
      const response = await paymentMethodService.getPaymentMethods(params);
      commit('SET_PAYMENT_METHODS', response);
      commit('SET_GET_PAYMENT_METHODS_STATUS', 'init');
      return response;
    } catch (error) {
      commit('SET_ERROR', error?.response?.data?.message || 'Erro ao buscar métodos de pagamento');
      commit('SET_GET_PAYMENT_METHODS_STATUS', 'init');
      throw error;
    }
  },

  async updatePaymentMethod({ commit }, { paymentMethodId, data }) {
    try {
      commit('SET_UPDATE_PAYMENT_METHOD_STATUS', 'loading');
      const response = await paymentMethodService.updatePaymentMethod(paymentMethodId, data);
      commit('SET_PAYMENT_METHOD', response);
      commit('SET_UPDATE_PAYMENT_METHOD_STATUS', 'init');
      return response;
    } catch (error) {
      commit('SET_ERROR', error?.response?.data?.message || 'Erro ao atualizar método de pagamento');
      commit('SET_UPDATE_PAYMENT_METHOD_STATUS', 'init');
      throw error;
    }
  },

  async deletePaymentMethod({ commit }, { paymentMethodId, iuguUserId }) {
    try {
      commit('SET_DELETE_PAYMENT_METHOD_STATUS', 'loading');
      const response = await paymentMethodService.deletePaymentMethod(paymentMethodId, iuguUserId);
      commit('SET_DELETE_PAYMENT_METHOD_STATUS', 'init');
      return response;
    } catch (error) {
      commit('SET_ERROR', error?.response?.data?.message || 'Erro ao deletar método de pagamento');
      commit('SET_DELETE_PAYMENT_METHOD_STATUS', 'init');
      throw error;
    }
  },
};

const mutations = {
  SET_PAYMENT(state, payment) {
    state.payment = payment;
  },

  SET_ERROR(state, error) {
    state.error = error;
  },

  CLEAR_PAYMENT(state) {
    state.payment = null;
    state.paymentStatus = null;
    state.error = null;
    state.pixData = null;
  },

  SET_PAYMENT_METHODS(state, paymentMethods) {
    state.paymentMethods = paymentMethods;
  },

  SET_PAYMENT_METHOD(state, paymentMethod) {
    state.paymentMethod = paymentMethod;
  },

  SET_REGISTER_PAYMENT_METHOD_STATUS(state, status) {
    state.registerPaymentMethodStatus = status;
  },

  SET_GET_PAYMENT_METHODS_STATUS(state, status) {
    state.getPaymentMethodsStatus = status;
  },

  SET_UPDATE_PAYMENT_METHOD_STATUS(state, status) {
    state.updatePaymentMethodStatus = status;
  },

  SET_DELETE_PAYMENT_METHOD_STATUS(state, status) {
    state.deletePaymentMethodStatus = status;
  },

  SET_GET_INVOICE_STATUS(state, status) {
    state.getInvoiceStatus = status;
  },

  SET_GET_PAYMENT_HISTORY_STATUS(state, status) {
    state.getPaymentHistoryStatus = status;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
